import {IconButton, Toolbar, DialogActions, styled} from '@mui/material';
import Icon from 'presentation/icons';

export const StyledCloseButton = styled(IconButton)`
	color: ${({theme}) => theme.palette.grey[600]};
	position: absolute;
	right: 8px;
	top: 8px;
`;

export const HeaderContainer = styled(Toolbar)`
	justify-content: space-between;
	min-height: 0px;
	padding: 8px 8px 8px 24px;
	background-color: ${({theme}) => theme.palette.other.planColor || theme.palette.primary.main};
`;

export const Footer = styled(DialogActions)`
	border-top: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
	padding: 8px 16px;
`;

export const StyledIcon = styled(Icon)`
	color: ${({theme}) => theme.palette.other.closeIcon};
`;
